/**
 * RA Header Theme Manager
 * Simple configuration-based system for header colors
 *
 * CONFIGURATION:
 * Add URL handles + section class pairs to the array below
 * Format: { url: '/collections/bluesync', section: '.ra-collections-v2' }
 * Anything NOT in this array defaults to WHITE
 */

(function () {
  "use strict";

  // ============================================
  // CONFIGURATION - Edit this array only
  // ============================================

  /**
   * URL + Section pairs that trigger BLUE header
   * Header turns blue when:
   * 1. Current URL matches the 'url' AND
   * 2. The section class is in viewport
   *
   * Examples:
   * { url: '/collections/bluesync', section: '.ra-collections-v2' }
   * { url: '/pages/science', section: '.ra-science-section' }
   */
  const BLUE_THEME_CONFIG = [
    {
      url: "/collections/day-lenses",
      section: ".ra-collections-v2",
    },
    {
      url: "/pages/terms-conditions",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/glasses-frame-size-chart",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/cookie-policy",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/privacy-policy",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/ra-return-policy",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/ra-shipping-policy",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/ra-warranty-policy",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/store-locator",
      section: null,
    },
    {
      url: "/pages/returns-refunds",
      section: null, // null = always blue on this URL
    },
    {
      url: "/collections/night-lenses",
      section: ".ra-collections-v2",
    },
    {
      url: "/collections/night-lenses",
      section: ".banner__content",
    },
    {
      url: "/pages/science",
      section: null, // null = always blue on this URL (no section check needed)
    },
    {
      url: "/pages/podcasts",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/blue-light-its-impact-on-our-health",
      section: null, // null = always blue on this URL
    },
    {
      url: "/collections/bluesync",
      section: ".ra-collections-v2",
    },
    {
      url: "/collections/bluesync",
      section: ".ra-why-exist-v2",
    },
    {
      url: "/collections/complete-set",
      section: null, // Always blue on this bundle collection
    },
    {
      url: "/collections/blue-light-protection-set",
      section: null, // Always blue on this bundle collection
    },
    {
      url: "/collections/circadian-sets",
      section: null, // Always blue on this bundle collection
    },
    {
      url: "/collections/sol-frames",
      section: null, // Always blue on this collection
    },
    {
      url: "/pages/how-blue-light-blocking-glasses-work",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/blue-light-its-impact-on-our-health",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/podcasts",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/science",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/circadian-rhythm",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/newsroom",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/blue-light-impact",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/how-blue-light-glasses-work",
      section: null, // null = always blue on this URL
    },
    {
      url: "/search",
      section: null, // null = always blue on this URL
    },
    {
      url: "/collections/all",
      section: null, // null = always blue on this URL
    },
    {
      url: "/collections/glasses",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/hsa-fsa",
      section: null, // null = always blue on this URL
    },
    {
      url: "/pages/affiliates",
      section: null, // null = always blue on this URL (light beige bg)
    },

    // Add more URL + section pairs here...
  ];

  /**
   * Global sections that trigger blue on ANY page when in view
   * These don't require a specific URL match
   */
  const GLOBAL_BLUE_SECTIONS = [
    ".ra-optics-v2-lenses-section",
    ".ra-bestsellers",
    ".ra-v2-celebrity-container",
    ".ra-v2-review-showcase-wrap",
    ".ra-optics-v2-faq",
    ".ra-lumios-faq",
    ".ra-why-bluelight-v2",
    ".ra-v2-benefits-section",
    ".ra-bundle-hero",
    ".ra-optics-v2-our-story",
  ];

  /**
   * Footer class that forces white header when header is positioned on it
   * Add footer classes here - header will turn white when positioned over footer
   */
  const FOOTER_CLASSES = [
    ".ra-optics-v2-footer",
    // Add more footer classes here...
  ];

  /**
   * Hero (above-the-fold) sections that force WHITE header when header is over them.
   * Use so AB test hero variants don't change when header color flips (v2 is shorter so blue sections appear sooner).
   */
  const HERO_WHITE_SECTIONS = [".hero-ab-v1", ".hero-ab-v2"];

  /**
   * When the page contains this section, header stays WHITE (dark background page – e.g. Lumios collection).
   * Checked by presence of the element; no viewport overlap needed.
   * Body class template-product-bulb = product.bulb.json PDP (same light header as Lumios pages).
   */
  const WHITE_HEADER_PAGE_SECTIONS = [".ra-collections-v2--lumios"];

  /**
   * On a white-header page, when the header reaches these sections it switches back to BLUE (normal).
   * Example: reviews section on Lumios collection has light background, so header goes blue again.
   */
  const WHITE_TO_BLUE_SECTIONS = [".ra-reviews-header-v2-container"];

  /**
   * Page classes that should have BLUE header (always blue, no section check)
   * These are automatically added by Liquid based on page type
   */
  const BLUE_THEME_PAGE_CLASSES = [
    "science-page",
    "blue-light-health-page",
    "podcast-page",
    "product-page",
    "bundles-page",
    "blog-page",
    "collections-list-page",
  ];

  // ============================================
  // END CONFIGURATION - Don't edit below
  // ============================================

  let header = null;
  let observers = [];
  let isInitialized = false;

  /**
   * Check if current URL matches a configured URL
   */
  function getMatchingConfig() {
    if (!BLUE_THEME_CONFIG.length) return null;

    const currentPath = window.location.pathname;

    return BLUE_THEME_CONFIG.find((config) => {
      // Exact match or starts with (for sub-pages)
      return currentPath === config.url || currentPath.startsWith(config.url + "/");
    });
  }

  /**
   * Check if header has any blue theme page class
   */
  function hasBlueThemePageClass() {
    if (!header || !BLUE_THEME_PAGE_CLASSES.length) return false;

    return BLUE_THEME_PAGE_CLASSES.some((pageClass) => header.classList.contains(pageClass));
  }

  /**
   * Check if header is directly on/over a specific section
   * Header turns blue when its bottom edge reaches the section's top edge
   */
  function isSectionInView(selector) {
    if (!selector || !header) return false;

    const section = document.querySelector(selector);
    if (!section) return false;

    const headerRect = header.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();

    // Header is "on" the section when header's bottom edge is at or past section's top edge
    // This means the header has scrolled to the point where it's directly over the section
    const headerBottom = headerRect.bottom;
    const sectionTop = sectionRect.top;

    return headerBottom >= sectionTop;
  }

  /**
   * Check if header is directly on/over any global blue section
   */
  function isAnyGlobalSectionInView() {
    if (!GLOBAL_BLUE_SECTIONS.length || !header) return false;

    return GLOBAL_BLUE_SECTIONS.some((selector) => isSectionInView(selector));
  }

  /**
   * Check if header is positioned on any footer
   * Footer forces white - uses same positioning logic as sections
   */
  function isHeaderOnFooter() {
    if (!header || !FOOTER_CLASSES.length) return false;

    for (const selector of FOOTER_CLASSES) {
      const footer = document.querySelector(selector);
      if (footer) {
        const headerRect = header.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        // Header is "on" the footer when header's bottom edge is at or past footer's top edge
        const headerBottom = headerRect.bottom;
        const footerTop = footerRect.top;

        if (headerBottom >= footerTop) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Check if page has a section that forces white header (e.g. Lumios collection with dark bg).
   * When present, header stays white until it reaches a section in WHITE_TO_BLUE_SECTIONS.
   */
  function isWhiteHeaderPage() {
    if (document.body && document.body.classList.contains("template-product-bulb")) {
      return true;
    }
    if (!WHITE_HEADER_PAGE_SECTIONS.length) return false;
    return WHITE_HEADER_PAGE_SECTIONS.some((selector) => document.querySelector(selector));
  }

  /**
   * On a white-header page: true when header has scrolled to be over one of the "back to blue" sections.
   */
  function isHeaderOnWhiteToBlueSection() {
    if (!WHITE_TO_BLUE_SECTIONS.length || !header) return false;
    return WHITE_TO_BLUE_SECTIONS.some((selector) => isSectionInView(selector));
  }

  /**
   * Check if header is over a visible hero section (AB test heroes).
   * Only when there's real overlap (header still within hero area). Once scrolled past, returns false so header can turn blue.
   */
  function isHeaderOverHero() {
    if (!header || !HERO_WHITE_SECTIONS.length) return false;

    const headerRect = header.getBoundingClientRect();

    for (const selector of HERO_WHITE_SECTIONS) {
      const section = document.querySelector(selector);
      if (!section) continue;
      const rect = section.getBoundingClientRect();
      // Skip hidden sections (display:none => height 0)
      if (rect.height <= 0) continue;
      // Overlap: header is over hero only while hero still overlaps the header (hero bottom below header top)
      if (rect.bottom > headerRect.top && rect.top < headerRect.bottom) {
        return true;
      }
    }
    return false;
  }

  /**
   * Set header theme - ONLY function that changes colors
   * Logo and menu items ALWAYS match - synchronized
   */
  function setHeaderTheme(theme) {
    if (!header) return;

    if (theme === "blue") {
      header.setAttribute("data-header-theme", "blue");
    } else {
      header.removeAttribute("data-header-theme");
    }
  }

  /**
   * Determine if header should be blue or white
   * Returns 'blue' or 'white'
   */
  function determineTheme() {
    if (!header) return "white";

    // Footer always takes precedence - white when header is positioned on footer
    if (isHeaderOnFooter()) {
      header.classList.add("footer-in-view");
      return "white";
    } else {
      header.classList.remove("footer-in-view");
    }

    // When header is over hero (v1 or v2), keep white so AB test doesn't change header color
    if (isHeaderOverHero()) {
      return "white";
    }

    // Page has dark background (e.g. Lumios collection) – header white until reviews (etc.) section
    if (isWhiteHeaderPage()) {
      if (isHeaderOnWhiteToBlueSection()) return "blue";
      return "white";
    }

    // Check page classes (always blue, no section check)
    if (hasBlueThemePageClass()) {
      return "blue";
    }

    // Check URL + Section pairs
    const matchingConfig = getMatchingConfig();
    if (matchingConfig) {
      // If section is null, always blue on this URL
      if (!matchingConfig.section) {
        return "blue";
      }
      // If section is specified, check if header is positioned on it
      if (isSectionInView(matchingConfig.section)) {
        return "blue";
      }
    }

    // Check global sections (work on any page)
    if (isAnyGlobalSectionInView()) {
      return "blue";
    }

    // Default to white (anything not in arrays)
    return "white";
  }

  /**
   * Update header theme based on current state
   */
  function updateTheme() {
    const theme = determineTheme();
    setHeaderTheme(theme);
  }

  /**
   * Initialize Intersection Observers for sections
   */
  function initializeObservers() {
    if (!header) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.1, 0.5, 1],
    };

    // Collect all unique sections to observe
    const sectionsToObserve = new Set();

    // Add sections from URL + Section pairs
    BLUE_THEME_CONFIG.forEach((config) => {
      if (config.section) {
        sectionsToObserve.add(config.section);
      }
    });

    // Add global sections
    GLOBAL_BLUE_SECTIONS.forEach((selector) => {
      sectionsToObserve.add(selector);
    });

    // Observe all sections
    sectionsToObserve.forEach((selector) => {
      const section = document.querySelector(selector);
      if (section) {
        const observer = new IntersectionObserver(() => {
          updateTheme();
        }, observerOptions);

        observer.observe(section);
        observers.push(observer);
      }
    });

    // Observe all footer classes
    FOOTER_CLASSES.forEach((selector) => {
      const footer = document.querySelector(selector);
      if (footer) {
        const footerObserver = new IntersectionObserver(() => {
          updateTheme();
        }, observerOptions);

        footerObserver.observe(footer);
        observers.push(footerObserver);
      }
    });
  }

  /**
   * Debounce function for scroll events
   */
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  /**
   * Initialize the theme system
   */
  function init() {
    header = document.querySelector(".ra-v2-header");

    if (!header) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
      }
      return;
    }

    if (isInitialized) return;
    isInitialized = true;

    // Check initial state immediately
    updateTheme();

    // Set up Intersection Observers
    initializeObservers();

    // Set up scroll listener (debounced for performance)
    const debouncedUpdate = debounce(updateTheme, 50);
    window.addEventListener("scroll", debouncedUpdate, { passive: true });
    window.addEventListener("resize", debouncedUpdate, { passive: true });

    // Listen for URL changes (for SPA navigation if applicable)
    let lastUrl = window.location.pathname;
    setInterval(() => {
      if (window.location.pathname !== lastUrl) {
        lastUrl = window.location.pathname;
        updateTheme();
      }
    }, 100);
  }

  // Initialize immediately
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Also run immediately if DOM ready
  if (document.readyState !== "loading") {
    init();
  }
})();
